import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

import'rxjs/add/operator/distinctUntilChanged';
import'rxjs/add/operator/pluck';

import { LayoutState } from './layout.state';
export class LayoutStore {
public readonly layoutState: Observable<LayoutState>;
private _layoutState: BehaviorSubject<LayoutState>;
private initialLayoutState: LayoutState = {
    isSidebarLeftCollapsed: false,
    isSidebarLeftExpandOnOver: false,
    isSidebarLeftMouseOver: false,
    isSidebarLeftMini: true,
    sidebarRightSkin: 'dark',
    isSidebarRightCollapsed: true,
    isSidebarRightOverContent: true,
    layout: 'normal',
    sidebarLeftMenu: [],
    skin: 'blue',
  };
/**
 * \@method constructor
 * @param {?} layoutConfig
 */
constructor(layoutConfig: LayoutState) {
    if(layoutConfig) {
      this.initialLayoutState = Object.assign(this.initialLayoutState, layoutConfig)
    }
    this._layoutState = new BehaviorSubject(this.initialLayoutState);
    this.layoutState = this._layoutState.asObservable();
  }
/**
 * [windowInnerHeight description]
 * \@method windowInnerHeight
 * @return {?}
 */
get windowInnerHeight(): Observable<number>{
    return /** @type {?} */(( <Observable<number>>this.layoutState.pluck('windowInnerHeight').distinctUntilChanged()));
  }
/**
 * [windowInnerWidth description]
 * \@method windowInnerWidth
 * @return {?}
 */
get windowInnerWidth(): Observable<number>{
    return /** @type {?} */(( <Observable<number>>this.layoutState.pluck('windowInnerWidth').distinctUntilChanged()));
  }
/**
 * [isSidebarLeftCollapsed description]
 * @return {?}
 */
get isSidebarLeftCollapsed(): Observable<boolean> {
    return /** @type {?} */(( <Observable<boolean>>this.layoutState.pluck('isSidebarLeftCollapsed').distinctUntilChanged()));
  }
/**
 * [isSidebarLeftExpandOnOver description]
 * \@method isSidebarLeftExpandOnOver
 * @return {?}
 */
get isSidebarLeftExpandOnOver(): Observable<boolean> {
    return /** @type {?} */(( <Observable<boolean>>this.layoutState.pluck('isSidebarLeftExpandOnOver').distinctUntilChanged()));
  }
/**
 * [isSidebarLeftMouseOver description]
 * \@method isSidebarLeftMouseOver
 * @return {?}
 */
get isSidebarLeftMouseOver(): Observable<boolean> {
    return /** @type {?} */(( <Observable<boolean>>this.layoutState.pluck('isSidebarLeftMouseOver').distinctUntilChanged()));
  }
/**
 * [isSidebarLeftMini description]
 * \@method isSidebarLeftMini
 * @return {?}
 */
get isSidebarLeftMini(): Observable<boolean> {
    return /** @type {?} */(( <Observable<boolean>>this.layoutState.pluck('isSidebarLeftMini').distinctUntilChanged()));
  }
/**
 * [sidebarRightSkin description]
 * \@method sidebarRightSkin
 * @return {?}
 */
get sidebarRightSkin(): Observable<string> {
    return /** @type {?} */(( <Observable<string>>this.layoutState.pluck('sidebarRightSkin').distinctUntilChanged()));
  }
/**
 * [isSidebarRightCollapsed description]
 * @return {?}
 */
get isSidebarRightCollapsed(): Observable<boolean> {
    return /** @type {?} */(( <Observable<boolean>>this.layoutState.pluck('isSidebarRightCollapsed').distinctUntilChanged()));
  }
/**
 * [isSidebarRightOverContent description]
 * \@method isSidebarRightOverContent
 * @return {?}
 */
get isSidebarRightOverContent(): Observable<boolean> {
    return /** @type {?} */(( <Observable<boolean>>this.layoutState.pluck('isSidebarRightOverContent').distinctUntilChanged()));
  }
/**
 * [sidebarLeftMenu description]
 * \@method sidebarLeftMenu
 * @return {?}
 */
get sidebarLeftMenu(): Observable<Array<any>> {
    return /** @type {?} */(( <Observable<Array<any>>>this.layoutState.pluck('sidebarLeftMenu').distinctUntilChanged()));
  }
/**
 * [sidebarLeftElementHeight description]
 * \@method sidebarLeftElementHeight
 * @return {?}
 */
get sidebarLeftElementHeight(): Observable<number> {
    return /** @type {?} */(( <Observable<number>>this.layoutState.pluck('sidebarLeftElementHeight').distinctUntilChanged()));
  }
/**
 * [layoutType description]
 * \@method layoutType
 * @return {?}
 */
get layout(): Observable<string> {
    return /** @type {?} */(( <Observable<string>>this.layoutState.pluck('layout').distinctUntilChanged()));
  }
/**
 * [skin description]
 * \@method skin
 * @return {?}
 */
get skin(): Observable<string> {
    return /** @type {?} */(( <Observable<string>>this.layoutState.pluck('skin').distinctUntilChanged()));
  }
/**
 * [wrapperClasses description]
 * \@method wrapperClasses
 * @return {?}
 */
get wrapperClasses(): Observable<string> {
    return /** @type {?} */(( <Observable<string>>this.layoutState.pluck('wrapperClasses').distinctUntilChanged()));
  }
/**
 * [sidebarLeftCollapsed description]
 * \@method sidebarLeftCollapsed
 * @param {?=} value
 * @return {?}
 */
public sidebarLeftCollapsed(value?: boolean): void {
    this._layoutState.next(
      Object.assign(this._layoutState.value, {isSidebarLeftCollapsed: value})
    );
  }
/**
 * [sidebarLeftExpandOnOver description]
 * \@method sidebarLeftExpandOnOver
 * @param {?=} value
 * @return {?}
 */
public sidebarLeftExpandOnOver(value?: boolean): void {
    this._layoutState.next(
      Object.assign(this._layoutState.value, {isSidebarLeftExpandOnOver: value})
    );
  }
/**
 * [setSidebarLeftElementHeight description]
 * \@method setSidebarLeftElementHeight
 * @param {?} value
 * @return {?}
 */
public setSidebarLeftElementHeight(value: number): void {
    this._layoutState.next(
      Object.assign(this._layoutState.value, {sidebarLeftElementHeight: value})
    );
  }
/**
 * [setSidebarRightSkin description]
 * \@method setSidebarRightSkin
 * @param {?=} value
 * @return {?}
 */
public setSidebarRightSkin(value?: string): void {
    this._layoutState.next(
      Object.assign(this._layoutState.value, {sidebarRightSkin: value})
    );
  }
/**
 * [sidebarLeftMouseOver description]
 * \@method sidebarLeftMouseOver
 * @param {?=} value
 * @return {?}
 */
public sidebarLeftMouseOver(value?: boolean): void {
    this._layoutState.next(
      Object.assign(this._layoutState.value, {isSidebarLeftMouseOver: value})
    );
  }
/**
 * [sidebarLeftMini description]
 * \@method sidebarLeftMini
 * @param {?=} value
 * @return {?}
 */
public sidebarLeftMini(value?: boolean): void {
    this._layoutState.next(
      Object.assign(this._layoutState.value, {isSidebarLeftMini: value})
    );
  }
/**
 * [sidebarRightCollapsed description]
 * \@method sidebarRightCollapsed
 * @param {?=} value
 * @return {?}
 */
public sidebarRightCollapsed(value?: boolean): void {
    this._layoutState.next(
      Object.assign(this._layoutState.value, {isSidebarRightCollapsed: value})
    );
  }
/**
 * [sidebarRightOverContent description]
 * \@method sidebarRightOverContent
 * @param {?=} value
 * @return {?}
 */
public sidebarRightOverContent(value?: boolean): void {
    this._layoutState.next(
      Object.assign(this._layoutState.value, {isSidebarRightOverContent: value})
    );
  }
/**
 * [setSidebarLeftMenu description]
 * \@method setSidebarLeftMenu
 * @param {?} value
 * @return {?}
 */
public setSidebarLeftMenu(value: string): void {
    this._layoutState.next(
      Object.assign(this._layoutState.value, {sSidebarLeftMenu: value})
    );
  }
/**
 * [setLayout description]
 * \@method setLayout
 * @param {?} value
 * @return {?}
 */
public setLayout(value: string): void {
    this._layoutState.next(
      Object.assign(this._layoutState.value, {layout: value})
    );
  }
/**
 * [setSkin description]
 * \@method setSkin
 * @param {?} value
 * @return {?}
 */
public setSkin(value: string): void {
    this._layoutState.next(
      Object.assign(this._layoutState.value, {skin: value})
    );
  }
/**
 * [setWrapperClasses description]
 * \@method setWrapperClasses
 * @param {?} value
 * @return {?}
 */
public setWrapperClasses(value: string): void {
    this._layoutState.next(
      Object.assign(this._layoutState.value, {wrapperClasses: value})
    );
  }
/**
 * [setWindowInnerHeight description]
 * \@method setWindowInnerHeight
 * @param {?} value
 * @return {?}
 */
public setWindowInnerHeight(value: number): void {
    this._layoutState.next(
      Object.assign(this._layoutState.value, {windowInnerHeight: value})
    );
  }
/**
 * [setWindowInnerWidth description]
 * \@method setWindowInnerWidth
 * @param {?} value
 * @return {?}
 */
public setWindowInnerWidth(value: number): void {
    this._layoutState.next(
      Object.assign(this._layoutState.value, {windowInnerWidth: value})
    );
  }
}

function LayoutStore_tsickle_Closure_declarations() {
/** @type {?} */
LayoutStore.prototype.layoutState;
/** @type {?} */
LayoutStore.prototype._layoutState;
/** @type {?} */
LayoutStore.prototype.initialLayoutState;
}

